import type { CachedData } from '../types/cachedDataInterface';
import CookieService from './CookieService';
import Environment from './Environment';

declare global {
  interface Window {
    sessionStorage: any;
  }
}

export default class CachedDataService {
  public static getStorageKey() {
    const suffix = Environment.location === 'production' ? '' : '_NP';
    return 'ADOBE_LAUNCH_CLIENT_STORAGE' + suffix;
  }

  public static getUID() {
    let spoid = CookieService.getCookie('cl_spoid');
    if (!spoid) {
      try {
        spoid = JSON.parse(CookieService.getDecodedCookie('cccSharedData')).spoid;
      } catch (_e) {
        spoid = '';
      }
    }
    return spoid;
  }

  public static get(): CachedData {
    const sessionData = window.sessionStorage.getItem(CachedDataService.getStorageKey());
    const uid = CachedDataService.getUID();
    const emptyUserData = { uid } as CachedData;
    let userData: CachedData;
    let returnData = emptyUserData;

    if (sessionData) {
      try {
        userData = JSON.parse(sessionData) as CachedData;
      } catch (_e) {
        return emptyUserData;
      }
      returnData = userData.uid === uid ? userData : emptyUserData;
    }

    return returnData;
  }
  public static set(data: CachedData = {} as CachedData) {
    window.sessionStorage.setItem(CachedDataService.getStorageKey(), JSON.stringify(data));
  }
}
